import { render, staticRenderFns } from "./TablesList.vue?vue&type=template&id=68fcd15c"
import script from "./TablesList.vue?vue&type=script&lang=js"
export * from "./TablesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports